import { IDialogAction } from './IDialogAction';

export const ADD_TAB_NOTIFICATION = 'ADD_TAB_NOTIFICATION';

export class AddTabNotificationAction implements IDialogAction {
    public readonly type = ADD_TAB_NOTIFICATION;
    public constructor(public payload: any) {}
    public middleware(): any {
        return;
    }
    public reducer(state: any): any {
        return state;
    }
}